import CTAButton from '../../ui/ctaButton';
import {
  ActionCardWrapper,
  ActionCardImageWrapper,
  ActionCardImage,
  ActionCardInfoContainer,
  ActionCardTitle,
  ActionCardSubtitle,
  ActionCardDescription,
  ActionCardTextWrapper,
} from './styles';

const ActionCard = ({
  title,
  subtitle,
  description = 'row',
  image,
  imageAlt,
  buttonText,
  onClick,
  direction = 'row',
  rounded = true,
}) => {
  const handleClick = () => {
    onClick && onClick();
  };

  return (
    <ActionCardWrapper direction={direction}>
      <ActionCardImageWrapper direction={direction}>
        <ActionCardImage src={image} alt={imageAlt} rounded={rounded} />
      </ActionCardImageWrapper>
      <ActionCardInfoContainer direction={direction}>
        <ActionCardTextWrapper direction={direction}>
          <ActionCardTitle>{title}</ActionCardTitle>
          {subtitle && <ActionCardSubtitle>{subtitle}</ActionCardSubtitle>}
          <ActionCardDescription
            dangerouslySetInnerHTML={{ __html: description }}
            direction={direction}
          />
        </ActionCardTextWrapper>
        <CTAButton text={buttonText} onClick={handleClick} />
      </ActionCardInfoContainer>
    </ActionCardWrapper>
  );
};

export default ActionCard;
